import { render, staticRenderFns } from "./LogoutVector.vue?vue&type=template&id=efdddb24&"
import script from "./LogoutVector.vue?vue&type=script&lang=js&"
export * from "./LogoutVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports